// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-expanded[data-v-08a216e4] {\n  transform: rotate(-180deg);\n}", ""]);
// Exports
module.exports = exports;
